
//Certifications

export class Certification {
  public PKCertificationId: string
  public CertificationName: string
  public IsActive: boolean
  public CertificationSequence: number
  public PathId: string

  constructor(PKCertificationId: string, CertificationName: string, IsActive: boolean, CertificationSequence: number) {
    this.PKCertificationId = PKCertificationId;
    this.CertificationName = CertificationName;
    this.IsActive = IsActive;
    this.CertificationSequence = CertificationSequence;
  }
}

//Modules

export class IQModule {
  public PKModuleId: string;
  public ModuleName: string;
  public IsActive: boolean;
  public ModuleSequence: number;
  public FkCertificationId: string;
  public TotalCount: number;
  public DesCount: number;
  public ObjCount: number;
  InterviewQuestion_Certification: Certification
}

//InterviewQuestions

export class InterviewQuestion {
  [x: string]: any;
  public PKInterviewQuestionId: string;
  public QuestionDescription: string;
  public Explanation: string;
  public CreatedDate: Date | null;
  public FKCreatedBy: string;
  public ModifiedDate: Date | null;
  public FKModifiedBy: string;
  public ViewCount: number;
  public FKPostedBy: string;
  public PostedDate: Date | null;
  public QuestionLevel: number;
  public IsDescriptive: boolean;
  public AverageRating: number;
  public Tags: string;
  public IsActive: boolean;
  public FKModuleId: string;
  public InterviewQuestion_Module: IQModule;
  public comment: string;
  public Comments: Comment[] = [];
  public Options: InterviewQuestion_Option[] = [];
  //panel/accordian Collapsable
  public IsCollapsed: boolean;
  public CurrentRate: number;
  public ShowRatingOptions: boolean;
  //Comment Collapse
  public IsCommentcollapsed: boolean;
  public QNo: number = 0;

  public InterviewQuestion_OptionArray: InterviewQuestion_Option[] = [];
}

//Options

export class InterviewQuestion_Option {
  public PKQuestionOptionId: string
  public OptionDescription: string
  public IsCorrect: boolean
  public Explanation: string
  public OptionSequence: number
  public FKInterviewQuestionId: string
  public InterviewQuestion: InterviewQuestion

  constructor(optionDescription: string = "", correctOption: boolean = false) {
    this.OptionDescription = optionDescription;
    this.IsCorrect = correctOption;
  }
}

//Comments

export class Comment {
  public PKCommentId: string
  public Comment: string
  public FKCommentedBy: string
  public CommentedDate: Date
  public IsActive: boolean
  public FKInterviewQuestionId: string
  public Votes:number
  public FkCommentedUser: string
  public IsEdit: boolean

}
export class CommentDTO {
  public PKCommentId: string
  public Comment: string
  public FKCommentedBy: string
  public CommentedDate: Date
  public IsActive: boolean
  public FKInterviewQuestionId: string
  public Votes: number
  public ParentCommentId:string
  public FkCommentedUser: string
  public IsEdit: boolean
  public IsExam: boolean
  public Replies:Comment[]=[]
  public isExpanded: boolean
  public ReportCount: number
  public Pages:number
  public TotalComments: number
  public RepliesCount: number

}
//Rating

export class Rating {
  public PKRatingId: string;
  public FKUserId: string;
  public Rating: number;
  public FKInterviewQuestionId: string;
  public InterviewQuestion: InterviewQuestion;
}

//UserInterviewQuestions

export class UserInterviewQuestion {
  PKUserQuestionId: string;
  FKUserId: string;
  FKUserName: string;
  FKUserEmail: string
  QuestionDescription: string;
  Explanation: string;
  PostedDate: Date;
  IsDescriptive: boolean;
  IsActive: boolean;
  Tags: string;
  FKModuleId: string;
  JSonOptionObject: string;
  Status: IQuestionStatus;
}
//votes for comment
export class UserCommentVote {
  PkvoterId: string;
  FkQuestionId: string;
  FkCommentId: string;
  FkuserId: string;
  Vote: number;
}


export class UsersCommentReport {
  pkReportId: string;
  fkQuestionId: string;
  fkuserId: string;
  reportCount: number;
  fkCommentId: string;
}

export enum IQuestionStatus {
  Pending,
  Approved,
  Rejected
}
